import React from 'react';
import {
  FDBodyText, FDHeadlineText, FDLozenge, FDStack, FDTitleText,
} from '@facet-wealth/design';

function RecommendedPlannerInfo({ resource }) {
  return (
    <FDStack direction={'column'} spacing={3} justifyContent={'center'} alignItems={'center'}>
      <FDStack direction={'column'} alignItems={'center'}>
        <FDHeadlineText value={resource.attr('recommendedPlannerName')} />
        <FDBodyText size={'lg'} value={resource.attr('recommendedPlannerRole')} />
      </FDStack>
      <FDStack direction={'column'} spacing={1} alignItems={'center'}>
        {
            resource.attr('recommendedPlannerInfoSnippets').resources().list().map((snippet) => <FDLozenge key={snippet.id()} color={snippet.attr('status')} label={snippet.attr('name')} size={'sm'} />)
          }
        <FDTitleText value={resource.attr('recommendedPlannerNextAvailability')} />
      </FDStack>
    </FDStack>
  );
}

export default RecommendedPlannerInfo;
